import Spinners from "components/common/Spinners";
import { CheckCircle, XCircle } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getCompanyInfo } from "store/actions/authSlice";
import {
    checkPaymentStatus
} from "store/actions/subscriptionSlice";
import { showAlert } from "store/reducers/alertReducer";

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const RedirectUrl = () => {
    const query = useQuery();
    const dispatch = useDispatch();
    const navigate = useNavigate();


    const { loading, allPlans } = useSelector(
        (state) => state.Subscriptions
    );
    const { isGettingCompanyDetails, orgnisationDetails ,isLoading } = useSelector((state) => state.auth);


    const tapId = query.get("tap_id");
    const [paymentStatus, setPaymentStatus] = useState(null);
    const [hasCheckedPayment, setHasCheckedPayment] = useState(false);

    useEffect(() => {
        dispatch(getCompanyInfo());

    }, [])

    // Call payment status immediately
    useEffect(() => {
        if (tapId && !hasCheckedPayment) {
            // setHasCheckedPayment(true);
            dispatch(checkPaymentStatus(tapId)).then((action) => {
                const { statusCode, success, data } = action?.payload;
                if (statusCode === 200 && success) {
                    setPaymentStatus(data?.gatewayStatus);
                } else {
                    setPaymentStatus(data?.gatewayStatus);
                }
            });
        }
    }, []);

    // Handle navigation when both payment status and auth details are ready
    // useEffect(() => {
    //   if (paymentStatus === "CAPTURED" || paymentStatus === "captured") {
    //     if (!isGettingDetails && authDetails) {
    //       const { isNewUser } = authDetails;
    //       if (isNewUser) {
    //         navigate("/welcome");
    //       } else {
    //         navigate("/dashboards/overview");
    //       }
    //     }
    //   }
    // }, [paymentStatus, isGettingDetails, authDetails]);

    const handleRetry = () => {
        const planType = localStorage.getItem("selectedPlan") || "STARTER";
        navigate(`/subscription?selectedPlan=${planType}`);
    };

    const handleGoToDashboard = () => {
        navigate("/dashboards/overview");
        return;
        if (!isGettingCompanyDetails && orgnisationDetails) {
            const { isCompanyDetailsSaved } = orgnisationDetails;
            if (!isCompanyDetailsSaved) {
                navigate("/welcome-message");
            } else {
            }
        }
    };

    return (
        <div className="two_column_pg payment_confirmation_wrapper">
            <div className="container position-relative">
                <div className="tcp_inner payment_confirmation">
                    {loading ? (
                        <Spinners />
                    ) : (
                        <div className="left">
                            {!loading &&
                                paymentStatus &&
                                paymentStatus.toLowerCase() !== "captured" ? (
                                <>
                                    <XCircle size={60} className="text_danger d-block mx-auto" />
                                    <h3 className="text_danger text-center">Payment Failed</h3>
                                    <p className="text_danger text-center mt-4">
                                        Unfortunately, your payment could not be completed. Please
                                        try again or contact support.
                                    </p>
                                    <button
                                        className="cancel_btn d-block mx-auto mt-3"
                                        onClick={handleRetry}
                                    >
                                        Retry
                                    </button>
                                </>
                            ) : paymentStatus === "CAPTURED" ||
                                paymentStatus === "captured" ? (
                                <>
                                    <CheckCircle size={60} className="text_primary mx-auto" />
                                    <h3 className="text_primary mt-3">Payment Successful</h3>
                                    <p className="text_primary mt-2">
                                        Thank you! Your payment has been completed successfully.
                                    </p>
                                    <button
                                        className="main_btn mt-3"
                                        onClick={handleGoToDashboard}
                                    >
                                        Go to Dashboard
                                    </button>
                                </>
                            ) : (
                                ""
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default RedirectUrl;
